module.exports = __webpack_public_path__ + "img/ivTest_sub61.1d76ed44.png";